module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-Italic.b85b8ae5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-Italic.woff
// module id = 525
// module chunks = 0